import useSWRMutation, {SWRMutationConfiguration} from 'swr/mutation';
import letrusAPI from '../axiosInstance';
import {GuardianData} from './types';

export function guardianConsentRequest(
  swrConfig?: SWRMutationConfiguration<
    null,
    Record<string, string[]>,
    string,
    GuardianData
  >,
) {
  return useSWRMutation<null, Record<string, string[]>, string, GuardianData>(
    `api/v1/guardian_consents/`,
    (url, {arg}) =>
      letrusAPI(url, {
        method: 'post',
        data: arg,
      }).then((res) => res.data),
    {...swrConfig, throwOnError: false},
  );
}
